angular.module("avant.mixpanel", ["avant.services"]);
require('./mixpanelService.coffee');
